import { render, staticRenderFns } from "./GeneralContent.vue?vue&type=template&id=2fac628a&"
import script from "./GeneralContent.vue?vue&type=script&lang=js&"
export * from "./GeneralContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports